<main>
  <header>
    <div class="headline">
      <h1>{{ lotItem?.id ? lotItem?.number : '' }}</h1>
    </div>
    <div class="buttons">
      <p-button
        icon="pi pi-print"
        *ngIf="lotItem?.id"
        label="{{ 'Common_Print_Label' | translateWF: 'Print Label' }}"
        size="small"
        [outlined]="true"
        (onClick)="printLotItemLabel(lotItem!)"
      />
      <span class="separator"></span>
      <p-button *ngIf="canEdit()" label="{{ 'Common_Save' | translateWF: 'Save' }}" (onClick)="save()" />
      <p-button label="{{ 'Common_Cancel' | translateWF: 'Cancel' }}" variant="outlined" [routerLink]="['/items-inventory']" />
    </div>
  </header>

  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <section>
      <div class="grid-12 gap-[2rem]">
        <div class="span-12">
          <form [formGroup]="lotItemForm">
            <!-- identification -->
            <p-panel class="mb-4" [header]="'ItemsInventory_Identification' | translateWF: 'Identification'">
              <ng-template pTemplate="icons">
                <div *ngIf="canEdit()" class="switch__wrapper">
                  {{ 'Common_Active' | translateWF: 'Active' }}
                  <p-toggleswitch />
                </div>
              </ng-template>
              <p-card>
                <div class="grid-3 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Items_Inventory_Lot_Item_ID' | translateWF: 'Lot Item ID' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="number" [disabled]="true" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Inventory_ItemItem' | translateWF: 'Items' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="itemDescription" [disabled]="true" />
                      <small class="mt-[.5rem]">{{ lotItem?.itemCode }}</small>
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_Packaging_Type' | translateWF: 'Packaging Type' }}</label>
                      <p-select class="w-full" [options]="packagingTypeOptions" formControlName="packagingType" placeholder="Select Type" [showClear]="true" [disabled]="true" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_Location' | translateWF: 'Location' }}</label>
                      <input type="text" pInputText class="w-full" [disabled]="true" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_WarehouseLocation' | translateWF: 'Wharehose Exact Location' }}</label>
                      <input type="text" pInputText class="w-full" [disabled]="true" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- notes -->
            <p-panel class="mb-4" [header]="'ItemsInventory_Notes' | translateWF: 'Notes'">
              <csl-standard-notes [userLite]="userLite!" [notes]="notes" (viewMore)="onViewMore()" [viewOnly]="!canEdit()" />
            </p-panel>
            <!-- dates -->
            <p-panel class="mb-4" [header]="'ItemsInventory_Dates' | translateWF: 'Dates'">
              <p-card>
                <div class="grid-3 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Items_Inventory_Date_Received' | translateWF: 'Date Received' }}</label>
                      <p-datepicker fluid class="w-full" [iconDisplay]="'input'" [showIcon]="true" formControlName="dateReceived" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_ManufacturedDate' | translateWF: 'Manufactured Date' }}</label>
                      <p-datepicker fluid class="w-full" [iconDisplay]="'input'" [showIcon]="true" formControlName="itemManufacturedDate" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_ExpiryDate' | translateWF: 'Expiry Date' }}</label>
                      <p-datepicker fluid class="w-full" [iconDisplay]="'input'" [showIcon]="true" formControlName="expiryDate" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- quantities -->
            <p-panel class="mb-4" [header]="'ItemsInventory_Quantities' | translateWF: 'Quantities'">
              <p-card>
                <div class="grid-2 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_NetQuantityCurrent' | translateWF: 'Net Quantity (Current)' }}</label>
                      <p-inputnumber class="w-full" formControlName="netQuantity" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_OriginalNetQuantity' | translateWF: 'Original Net Quantity' }}</label>
                      <p-inputnumber class="w-full" formControlName="originalNetQuantity" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_GrossQuantityCurrent' | translateWF: 'Gross Quantity (Current)' }}</label>
                      <p-inputnumber class="w-full" formControlName="grossQuantity" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_OriginalGrossQuantity' | translateWF: 'Original Gross Quantity' }}</label>
                      <p-inputnumber class="w-full" formControlName="originalGrossQuantity" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- manufacturer -->
            <p-panel class="mb-4" [header]="'ItemsInventory_ManufacturerInformation' | translateWF: 'Manufacturer Information'">
              <p-card>
                <div class="grid-3 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Manufacturer' | translateWF: 'Manufacturer' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="manufacturer" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Manufacturer_Label_ID' | translateWF: 'Manufacturer Label ID' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="providerLabelNumber" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Manufacturer_Lot_Number' | translateWF: 'Manufacturer Lot Number' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="providerLotId" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- provider and finance -->
            <p-panel
              class="mb-4"
              [header]="
                'ItemsInventory_ProviderAndFinanceInformation'
                  | translateWF
                    : 'Provider and Finance
              Information'
              "
            >
              <ng-template pTemplate="icons">
                <div *ngIf="canEdit()" class="switch__wrapper">
                  {{ 'ItemsInventory_ReceivedLot' | translateWF: 'Received Lot' }}
                  <p-toggleswitch />
                </div>
              </ng-template>
              <p-card>
                <div class="grid-2 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Items_Inventory_Provider' | translateWF: 'Provider' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="providerName" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Common_Invoice' | translateWF: 'Invoice' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="invoiceNumber" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- parent lot item -->
            <p-panel class="mb-4" [header]="'Parent_Lot_Item' | translateWF: 'Parent Lot Item'">
              <p-card>
                <div class="grid-2 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'ItemsInventory_ParentKey' | translateWF: 'Parent Key' }}</label>
                      <input type="text" pInputText class="w-full" formControlName="parentKey" />
                      <small *ngIf="lotItemForm.get('parentKey')?.value" class="cursor-pointer mt-[.5rem]" (click)="redirectParentKey()"
                        >{{ lotItemForm.get('parentKey')?.value }} <i class="pi pi-arrow-up-right" style="font-size: 0.8rem"></i>
                      </small>
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- consumption entries -->
            <p-panel class="mb-4" [header]="'ItemsInventory_ConsumptionEntries' | translateWF: 'Consumption Entries'">
              <p-card data-variant="compact">
                <div class="grid-1 gap-[1rem]">
                  <div class="span-1">
                    @if (consumptionEntries.length > 0) {
                      <p-table [value]="consumptionEntries">
                        <ng-template #header>
                          <tr>
                            <th>{{ 'Common_Quantity' | translateWF: 'Quantity' }}</th>
                            <th>{{ 'Common_Date' | translateWF: 'Date' }}</th>
                            <th>{{ 'ItemsInventory_Initiator' | translateWF: 'Initiator' }}</th>
                            <th>{{ 'Common_User' | translateWF: 'User' }}</th>
                            <th>{{ 'RollQcDetail_Comments' | translateWF: 'Comments' }}</th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-consumption>
                          <tr>
                            <td>{{ consumption.quantity }}</td>
                            <td>{{ consumption.date | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                            <td>{{ getEntityDefinitionName(consumption.initiator.entityDefinitionCode) }}</td>
                            <td>{{ consumption.user.username }}</td>
                            <td>{{ consumption.comments }}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    } @else {
                      <p-message severity="secondary">{{
                        'Not_Available_Entries'
                          | translateWF
                            : 'There are not available
                    entries'
                      }}</p-message>
                    }
                  </div>
                </div>
              </p-card>
            </p-panel>
            <!-- addition entries -->
            @if (additionEntries.length > 0) {
              <p-panel class="mb-4" [header]="'ItemsInventory_AdditionEntries' | translateWF: 'Addition Entries'">
                <p-card data-variant="compact">
                  <p-table [value]="additionEntries">
                    <ng-template #header>
                      <tr>
                        <th>{{ 'ItemsInventory_AdditionType' | translateWF: 'Type' }}</th>
                        <th>{{ 'Common_Quantity' | translateWF: 'Quantity' }}</th>
                        <th>{{ 'Common_Date' | translateWF: 'Date' }}</th>
                        <th>{{ 'ItemsInventory_SourceLotItem' | translateWF: 'Source Lot Item' }}</th>
                        <th>{{ 'Common_User' | translateWF: 'User' }}</th>
                        <th>{{ 'RollQcDetail_Comments' | translateWF: 'Comments' }}</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-addition>
                      <tr>
                        <td>
                          <p-tag [value]="getAdditionTypeLabel(addition.type)" [severity]="addition.type === AdditionEntryType.Merge ? 'info' : 'secondary'" />
                        </td>
                        <td>{{ addition.quantity }}</td>
                        <td>{{ addition.date | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        <td>
                          <a class="text-primary cursor-pointer" [routerLink]="['/items-inventory-detail']" [queryParams]="{ id: addition.initiator.reference }">
                            {{ 'ItemsInventory_ViewSource' | translateWF: 'View source' }}
                          </a>
                        </td>
                        <td>{{ addition.user?.username }}</td>
                        <td>{{ addition.comments }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-card>
              </p-panel>
            }
            <!-- record details -->
            <p-panel class="mb-4" [header]="'Record_Details' | translateWF: 'Record Details'">
              <p-card>
                <div class="grid-2 gap-[1rem]">
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Created_By' | translateWF: 'Created By' }}</label>
                      <input type="text" pInputText class="w-full" [value]="lotItem?.createdBy" [disabled]="true" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Created_Date' | translateWF: 'Created Date' }}</label>
                      <p-datepicker fluid class="w-full" [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" [formControl]="createdDate" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Modified_By' | translateWF: 'Modified By' }}</label>
                      <input type="text" pInputText class="w-full" [value]="lotItem?.modifiedBy" [disabled]="true" />
                    </div>
                  </div>
                  <div class="span-1">
                    <div class="form-box">
                      <label>{{ 'Modified_Date' | translateWF: 'Modified Date' }}</label>
                      <p-datepicker fluid class="w-full" [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" [formControl]="modifiedDate" />
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>
          </form>
        </div>
      </div>
    </section>
  </div>
</main>
